<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Webhook Details'"
      [canGoBack]="true"
      [customBack]="webhookDetailsBackPage" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper [class]="isRightSideContent ? 'right-side-scroll-enabled' : ''">

    @if (loaded) {
      <tidy-card>
        <tidy-row class="extra-bottom-padding">
          <tidy-text
            [header]="webhookUrl" />
        </tidy-row>
        <tidy-row class="vertical-align-center extra-bottom-padding">
          <tidy-image
            [src]="'assets/img/url.svg'"
            class="body-size" />
          <tidy-text
            [body]="webhookChannel === 'webhook' ? 'Standard Webhook' : 'Slack Webhook'">>
          </tidy-text>
        </tidy-row>
        @if (webhookDescription) {
          <tidy-row class="vertical-align-center extra-bottom-padding">
            <tidy-image
              [src]="'assets/img/info.svg'"
              class="body-size" />
            <tidy-text
              [body]="webhookDescription" />
          </tidy-row>
        }
        <tidy-row class="vertical-align-center extra-bottom-padding">
          @if (webhookState === 'inactive') {
            <tidy-image
              [src]="'assets/icon/pause.svg'"
              class="body-size" />
          }
          @if (webhookState === 'active') {
            <tidy-image
              [src]="'assets/icon/check.svg'"
              class="body-size" />
          }
          <tidy-text
            [body]="'Status:'" /><span>&nbsp;</span>
            <tidy-text
              [body]="webhookState | titlecase" />
          </tidy-row>
          @if (webhookTeamName !== 'undefined' && isAccountAdmin) {
            <tidy-row class="vertical-align-middle extra-bottom-padding">
              <tidy-image
                [src]="'assets/img/organization.svg'"
                class="body-size" />
              <tidy-text
                [body]="'Group:'" /><span>&nbsp;</span>
                <tidy-text
                  [body]="webhookTeamName" />
              </tidy-row>
            }
            <tidy-row class="vertical-align-middle extra-bottom-padding">
              <tidy-image
                [src]="'assets/img/alert.svg'"
                class="body-size" />
              <tidy-text
                [body]="'Listening to events:'" /><span>&nbsp;</span>
                <tidy-text
                  [body]="webhookEvents" />
              </tidy-row>
              <tidy-card-button (action)="runTestWebhook()">
                <tidy-row class="vertical-align-center">
                  <tidy-image
                    [src]="'assets/icon/send.svg'"
                    class="header-size" />
                  <tidy-text
                    [body]="'Test Webhook'" />
                </tidy-row>
              </tidy-card-button>
              <tidy-card-button (action)="goToEditWebhookPage()">
                <tidy-row class="vertical-align-center">
                  <tidy-image
                    [src]="'assets/img/edit.svg'"
                    class="body-size" />
                  <tidy-text
                    [body]="'Edit Webhook'" />
                </tidy-row>
              </tidy-card-button>
              <tidy-card-button (action)="confirmWebhookDeletion()">
                <tidy-row class="vertical-align-center">
                  <tidy-image
                    [src]="'assets/icon/block.svg'"
                    class="body-size" />
                  <tidy-text
                    [body]="'Delete Webhook'" />
                </tidy-row>
              </tidy-card-button>
              @if (webhookState === 'active') {
                <tidy-card-button (action)="confirmWebhookDeactivation()">
                  <tidy-row class="vertical-align-center">
                    <tidy-image
                      [src]="'assets/icon/pause.svg'"
                      class="body-size" />
                    <tidy-text
                      [body]="'Disable Webhook'" />
                  </tidy-row>
                </tidy-card-button>
              }
              @if (webhookState === 'inactive') {
                <tidy-card-button (action)="confirmWebhookActivation()">
                  <tidy-row class="vertical-align-center">
                    <tidy-image
                      [src]="'assets/icon/check.svg'"
                      class="body-size" />
                    <tidy-text
                      [body]="'Activate Webhook'" />
                  </tidy-row>
                </tidy-card-button>
              }
            </tidy-card>
            <tidy-row class="extra-top-padding extra-bottom-padding">
              <tidy-text
                [header]="'Webhook Attempts'" /><br>
              <tidy-text
                [body]="'Attempts to send an event to your endpoint in the past 15 days'" />
            </tidy-row>
            @if (attempts?.length === 0) {
              <tidy-alert>
                <tidy-row>
                  <tidy-text
                    [body]="'No recent webhook attempts'" />
                </tidy-row>
              </tidy-alert>
            }
            @for (attempt of attempts; track attempt) {
              <tidy-card>
                <tidy-card-button (action)="goToWebhookAttempt(attempt, attempt.status)">
                  <tidy-row>
                    <tidy-text
                      [body]="(attempt?.created_at | parseDateTime:'dddd MMM d':'local') + ' ' + (attempt?.created_at | parseDateTime:'h:mma':'local') + ' - '" />
                    <tidy-text
                      [body]="attempt?.status | titlecase"
                      [ngClass]="attempt?.status === 'failed' ? 'red' : 'green'" />
                  </tidy-row>
                </tidy-card-button>
              </tidy-card>
            }
            @if (errorMessage) {
              <tidy-error-message
                [text]="errorMessage" />
            }
          }
        </tidy-wrapper>
      </ng-template>

      @if (!isRightSideContent) {
        <app-scroll-wrapper [templateContent]="content" />
      }

      @if (isRightSideContent) {
        <ion-content class="ion-content-right-column">
          <ng-container *ngTemplateOutlet="content" />
        </ion-content>
      }
